import { Enumify } from 'enumify-ts';
class DayOfWeekType extends Enumify() {
    description;
    static MONDAY = new DayOfWeekType("Monday");
    static TUESDAY = new DayOfWeekType("Tuesday");
    static WEDNESDAY = new DayOfWeekType("Wednesday");
    static THURSDAY = new DayOfWeekType("Thursday");
    static FRIDAY = new DayOfWeekType("Friday");
    static SATURDAY = new DayOfWeekType("Saturday");
    static SUNDAY = new DayOfWeekType("Sunday");
    static _ = DayOfWeekType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static BUSINESS_DAYS = [
        DayOfWeekType.MONDAY,
        DayOfWeekType.TUESDAY,
        DayOfWeekType.WEDNESDAY,
        DayOfWeekType.THURSDAY,
        DayOfWeekType.FRIDAY
    ];
    static checkboxOptions() {
        return DayOfWeekType.values.map(it => {
            const option = {
                label: it.description,
                value: it.key
            };
            return option;
        });
    }
}
export default DayOfWeekType;
